"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInstance = getInstance;
exports.setLocale = setLocale;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _checker = _interopRequireDefault(require("./components/checker"));

var _formatMessage = _interopRequireDefault(require("./format-message"));

var _nodeChecker = _interopRequireDefault(require("./node-checker"));

let instance;
const pendingInstanceCallbacks = [];
const container = document.createElement("div");
container.className = "tinymce-a11y-checker-container";
document.body.appendChild(container);
tinymce.create("tinymce.plugins.AccessibilityChecker", {
  init: function (ed) {
    ed.addCommand("openAccessibilityChecker", function (ui, {
      done,
      config,
      additionalRules,
      mountNode
    }) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_checker.default, {
        getBody: ed.getBody.bind(ed),
        editor: ed,
        additionalRules: additionalRules,
        mountNode: mountNode
      }), container, function () {
        // this is a workaround for react 16 since ReactDOM.render is not
        // guaranteed to return the instance synchronously (especially if called
        // within another component's lifecycle method eg: componentDidMount). see:
        // https://github.com/facebook/react/issues/10309#issuecomment-318434635
        instance = this;
        if (config) getInstance(instance => instance.setConfig(config));
        pendingInstanceCallbacks.forEach(cb => cb(instance));
        instance.check(done);
      });
    });
    ed.addCommand("checkAccessibility", function (ui, {
      done,
      config,
      additionalRules
    }) {
      (0, _nodeChecker.default)(ed.getBody(), done, config, additionalRules);
    });
    ed.ui.registry.addButton("check_a11y", {
      title: (0, _formatMessage.default)("Check Accessibility"),
      onAction: _ => ed.execCommand("openAccessibilityChecker"),
      icon: "a11y"
    });
  }
}); // Register plugin

tinymce.PluginManager.add("a11y_checker", tinymce.plugins.AccessibilityChecker);

function getInstance(cb) {
  if (instance != null) {
    return cb(instance);
  }

  pendingInstanceCallbacks.push(cb);
}

function setLocale(locale) {
  const options = _formatMessage.default.setup();

  options.locale = locale;

  _formatMessage.default.setup(options);
}